module.exports = __webpack_public_path__ + "images/95a103bbd4f28a62f119a9ad2279e698.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/saastopankki.png
// module id = 1527
// module chunks = 1